<template>
  <div id="spcc">
    <div v-if="layout=='hoesch'">
      <hoesch v-bind:languages="languages" />
    </div>
    <div v-if="layout=='gooimeer'">
      <gooimeer v-bind:languages="languages" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import translation_nl from './assets/translations.json'
import translation_en from './assets/translations_en.json'
import translation_de from './assets/translations_de.json'
import translation_fr from './assets/translations_fr.json'
export default {
  name: 'Spcc',
  props: ['layout', 'languages'],
  data () {
    return {
      agreeVal : false,
      disagreeVal : false,
      calculation : false,
      sent_email: false,
      loading : false,
      language : 'nl',
      currentInput : '',
      translationsFiles : {
        'nl' : translation_nl,
        'en' : translation_en,
        'de' : translation_de,
        'fr' : translation_fr,
      },
      result : {},
      confirm: {},
      lifespanNext : '',
      protectionvalues: false,
      values : {
        profiletype: {
          visible : true,
          inputtype    : 'select',
          value   : false,
          disp_value   : false,
          values  : {},
          required: true,
        },
        profile_id: {
          visible     : true,
          inputtype   : 'select',
          value       : false,
          values  : {},
          required: true,
        },
        steelquality_id: {
          visible : true,
          inputtype    : 'select',
          value   : false,
          disp_value   : false,
          values  : {

          },
          required: true,
        },
        protectionfront: {
          visible : true,
          inputtype    : 'select',
          value   : 0,
          values  : {},
          required: true,
        },
        protectionback: {
          visible : true,
          inputtype    : 'select',
          value   : 0,
          values  : {},
          required: true,
        },
        norm_id:{
          visible : true,
          inputtype    : 'select',
          value   : false,
          disp_value   : false,
          values  : {

          },
          required: true,
        },
        lifespan: {
          visible   : false,
          inputtype : 'select',
          value     : false,
          values    : {

          },
          required  : true,
        },
        front_corrosion_id: {
          visible   : false,
          inputtype : 'select',
          value     : false,
          values    : {

          },
          required  : true,
        },
        front_mm_total: {
          visible   : false,
          inputtype : 'number',
          value     : false,
          values    : {

          },
          required  : true,
        },
        front_mm_rate: {
          visible   : false,
          inputtype : 'number',
          value     : false,
          values    : {

          },
          required  : true,
        },
        back_corrosion_id: {
          visible   : false,
          inputtype : 'select',
          value     : false,
          values    : {

          },
          required  : true,
        },
        back_mm_total: {
          visible   : false,
          inputtype : 'number',
          value     : false,
          values    : {

          },
          required  : true,
        },
        back_mm_rate: {
          visible   : false,
          inputtype : 'number',
          value     : false,
          values    : {

          },
          required  : true,
        },
        projectnaam: {
          visible : true,
          inputtype    : 'text',
          value   : '',
          disp_value   : false,
          values  : {

          },
          required: false,
        },
        naam: {
          visible : true,
          inputtype    : 'text',
          value   : '',
          disp_value   : false,
          values  : {

          },
          required: false,
        },
        firma: {
          visible : true,
          inputtype    : 'text',
          value   : '',
          disp_value   : false,
          values  : {

          },
          required: false,
        },
        emailadres: {
          visible : true,
          inputtype    : 'email',
          value   : '',
          disp_value   : false,
          values  : {

          },
          required: false,
        },
        optin: {
          visible : true,
          inputtype    : 'select',
          value   : false,
          disp_value   : false,
          values  : {

          },
          required: true,
        }
      }
    }
  },
  computed: {
    input : function(){ 
      return this.values;
    },
    showEmailCalculation : function(){
      if(!this.agreeVal){
        return false;
      }
      if(!this.calculation){
        return false;
      }
      if(this.optin == 0){
        return false;
      }
      if(this.sent_email){
        return false;
      }
      if(!this.input.emailadres.value){
        return false;
      }
      return true;
    },
    inputOrdered : function(){
      var ordered = [
                      'profiletype',
                      'profile_id',
                      'g_kgm2',

                      'steelquality_id',
                      'lifespan',
                      'norm_id',
                      'front_corrosion_id',
                      'front_mm_total',
                      'front_mm_rate',
                      'back_corrosion_id',
                      'back_mm_total',
                      'back_mm_rate',

                      'protectionfront',
                      'protectionback',
                      'corrosiontotal_front',
                      'corrosiontotal_back',
                    ];
      var returnvalues = {};

      for(let index in ordered){
        let item = ordered[index];
        let val = '';
        if(item=='g_kgm2'){
          val = {
                  visible     : true,
                  inputtype   : 'display',
                  value       : this.results[item],
                  values      : {},
                  required    : false,
                };
        }else if(item=='corrosiontotal_front'){
          val = {
                  visible     : true,
                  inputtype   : 'display',
                  value       : this.results[item],
                  values      : {},
                  required    : false,
                };
        }else if(item=='corrosiontotal_back'){
          val = {
                  visible     : true,
                  inputtype   : 'display',
                  value       : this.results[item],
                  values      : {},
                  required    : false,
                };
        }else{
          val = this.values[item];
        }
        returnvalues[item] = val;
      }
      return returnvalues;
    },
    currentLanguage : function(){
      return this.language;
    },
    translations : function(){
      return this.translationsFiles[this.language];
    },
    protection : function(){
      return this.protectionvalues;
    },
    requiredPassed : function(){
      var passed = true
      
      for(let item in this.values){
        if(this.values[item].required){
          if(this.values[item].value === false){
            return false;
          }
        }
      }
      return passed;
    },
    results : function(){
      return this.result;
    }
  },
  methods:{
    itemPassed : function(item){
      if(this.values[item].visible){
        if(this.values[item].required){
          if(this.values[item].value === false){
            return false;
          }
        }
      }
      return true
    },
    resetCalculation(){
      for(let item in this.values){
        this.values[item].value = false;
        this.values[item].disp_value = false;
      }
      this.values['protectionfront'].value      = 0;
      this.values['protectionfront'].disp_value = 0 + ' ' + this.translations['year'];
      this.values['protectionback'].value      = 0;
      this.values['protectionback'].disp_value = 0 + ' ' + this.translations['year'];
      this.currentInput = 'profiletype';

      this.sent_email = false;
      this.calculation = false;
    },
    disagreePressed(){
      this.agreeVal = false;
      this.disagreeVal = true;
    },
    'agreePressed': function(){
      this.agreeVal = true;
      this.disagreeVal = false;
      // this.demo();
    },
    languageSelect(lang){
      this.language = lang;
      this.getTranslations();
    },
    change(value){
      switch(value) {
        case 'profiletype':
            this.values[value].disp_value = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].text;
            this.values.profile_id.value = false;
            this.values.profile_id.disp_value = false;
            this.profielenApi(document.getElementById('input_'+value).value);
          break;
        case 'profile_id':
            this.values[value].disp_value = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].text;
            this.currentInput = 'steelquality_id';
          break;
        case 'steelquality_id':
          this.values[value].disp_value = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].text;
            this.currentInput = 'norm_id';
          break;
        case 'norm_id':
            this.values[value].disp_value = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].text;
            let norm_id = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].value;
            axios.get('https://api.sheetpilecorrosioncalculator.com/api/norm/'+norm_id)
                  .then(response => {
                    let normdata = response.data.data;
                    let normSelects = ['lifespan', 'front_mm_rate', 'front_mm_total', 'front_corrosion_id', 'back_mm_rate', 'back_mm_total', 'back_corrosion_id'];
                    this.lifespanNext = 'front_mm_total';
                    for(let item in normdata){
                      if(normSelects.indexOf(item)>=0){
                        if(normdata[item] == 0){
                          this.values[item].visible = false;
                          this.values[item].value = false;
                          this.values[item].disp_value = false;
                          this.values[item].required = false;
                        }else{
                          this.values[item].required = true;
                          this.values[item].visible = true;
                          if(this.values['lifespan'].visible){
                            if(item=='front_mm_total'){
                              this.lifespanNext = 'front_mm_total';
                            }
                            if(item=='front_mm_rate'){
                              this.lifespanNext = 'front_mm_rate';
                            }
                            if(item=='front_corrosion_id'){
                              this.lifespanNext = 'front_corrosion_id';
                            }
                          }
                        }
                      }
                    }
                    this.normValues();
                    if(this.values['lifespan'].visible){
                      this.currentInput = 'lifespan';
                    }else{
                      this.currentInput = 'front_mm_total';
                    }
                  })
                  .catch(error => {
                    console.log(error);
                  });
          break;

        case 'lifespan':
            this.values[value].disp_value = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].text;
            this.currentInput = this.lifespanNext;
          break;

        case 'front_corrosion_id':
            this.values[value].disp_value = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].text;
            this.currentInput = 'back_corrosion_id';
          break;

        case 'back_corrosion_id':
            this.values[value].disp_value = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].text;
            this.currentInput = 'projectnaam';
          break;

        case 'front_mm_total':
            this.values[value].disp_value = document.getElementById('input_'+value).value.toString();
            this.currentInput = 'back_mm_total';
          break;

        case 'back_mm_total':
            this.values[value].disp_value = document.getElementById('input_'+value).value.toString();
            this.currentInput = 'projectnaam';
          break;

        case 'front_mm_rate':
            this.values[value].disp_value = document.getElementById('input_'+value).value.toString();
            this.currentInput = 'back_mm_rate';
          break;

        case 'back_mm_rate':
            this.values[value].disp_value = document.getElementById('input_'+value).value.toString();
            this.currentInput = 'projectnaam';
          break;

        case 'projectnaam':
            this.values[value].disp_value = document.getElementById('input_'+value).value.toString();
            this.currentInput = 'naam';
          break;

        case 'naam':
            this.values[value].disp_value = document.getElementById('input_'+value).value.toString();
            this.currentInput = 'firma';
          break;

        case 'firma':
            this.values[value].disp_value = document.getElementById('input_'+value).value.toString();
            this.currentInput = 'emailadres';
          break;

        case 'emailadres':
            this.values[value].disp_value = document.getElementById('input_'+value).value.toString();
            this.currentInput = 'optin';
          break;

        case 'optin':
            this.values[value].disp_value = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].text;
          break;

        default:
            console.log('change', value);
          break;
      }

      if(this.calculation){
        this.doCalculation();
      }
    },
    profielenApi(profiletype){
      if(!profiletype){
        this.currentInput = 'profiletype';
        return false;
      }

      if(profiletype==3){
        profiletype = 1;
      }
      if(profiletype==4){
        profiletype = 2;
      }
      axios.get('https://api.sheetpilecorrosioncalculator.com/api/profielen/'+profiletype)
            .then(response => {
              var profiles = new Array();
              for (var i = 0; i < response.data.data.length; i++) {
                let id = response.data.data[i].id;
                let name = response.data.data[i].name;
                profiles[id] = {'value' : id, 'text' : name};
              }
              this.values.profile_id.values = profiles;
              this.currentInput = 'profile_id';
            })
            .catch(error => {
              console.log(error);
            })
    },
    normValues(){
      var norm_id = this.values.norm_id.value;
      axios.get('https://api.sheetpilecorrosioncalculator.com/api/normwaarden/'+norm_id)
          .then(response => {
            var normvalues = new Array();
            for (var i = 0; i < response.data.data.length; i++) {
              let id = response.data.data[i].id;
              let name = response.data.data[i].name;
              normvalues[id] = {'value' : id, 'text' : name};
            }

            this.values.front_corrosion_id.values = normvalues;
            this.values.back_corrosion_id.values = normvalues;

          })
          .catch(error => {
            console.log(error);
          });
    },
    getTranslations(language){
      var language = this.language;
      axios.get('https://api.sheetpilecorrosioncalculator.com/api/normen/'+language)
          .then(response => {
            var norm = new Array();
            for (var i = 0; i < response.data.data.length; i++) {
              let id = response.data.data[i].id;
              let name = response.data.data[i].name;
              norm[id] = {'value' : id, 'text' : name};
            }
            this.values.norm_id.values = norm;
          })
          .catch(error => {
            console.log(error);
          });

      axios.get('https://api.sheetpilecorrosioncalculator.com/api/profieltypen/'+language)
            .then(response => {
              var profiletype = new Array();
              for (var i = 0; i < response.data.data.length; i++) {
                let id = response.data.data[i].id;
                let name = response.data.data[i].name;
                profiletype[id] = {'value' : id, 'text' : name};
              }
              this.values.profiletype.values = profiletype;
            })
            .catch(error => {
              console.log(error);
            });

      let lifespanValues = [];
      for(var i=0; i<=100; i++){
        lifespanValues.push({value : i, text: i + ' ' + this.translations['year']});
        i = i+4;
      }
      this.values['lifespan'].values = lifespanValues;

      this.protectionvalues =  [
        {value : 0, text: 0 + ' ' + this.translations['year']},
        {value : 1, text: 1 + ' ' + this.translations['year']},
        {value : 2, text: 2 + ' ' + this.translations['year']},
        {value : 3, text: 3 + ' ' + this.translations['year']},
        {value : 4, text: 4 + ' ' + this.translations['year']},
        {value : 5, text: 5 + ' ' + this.translations['year']},
        {value : 6, text: 6 + ' ' + this.translations['year']},
        {value : 7, text: 7 + ' ' + this.translations['year']},
        {value : 8, text: 8 + ' ' + this.translations['year']},
        {value : 9, text: 9 + ' ' + this.translations['year']},
        {value : 10, text: 10 + ' ' + this.translations['year']},
        {value : 11, text: 11 + ' ' + this.translations['year']},
        {value : 12, text: 12 + ' ' + this.translations['year']},
        {value : 13, text: 13 + ' ' + this.translations['year']},
        {value : 14, text: 14 + ' ' + this.translations['year']},
        {value : 15, text: 15 + ' ' + this.translations['year']},
        {value : 16, text: 16 + ' ' + this.translations['year']},
        {value : 17, text: 17 + ' ' + this.translations['year']},
        {value : 18, text: 18 + ' ' + this.translations['year']},
        {value : 19, text: 19 + ' ' + this.translations['year']},
        {value : 20, text: 20 + ' ' + this.translations['year']},
      ];
      this.values['protectionfront'].values = this.protectionvalues;
      this.values['protectionback'].values = this.protectionvalues;
      this.normValues();

      this.values['optin'].values = [
        {value : 0, text: this.translations['disagree']},
        {value : 1, text: this.translations['agree']},
      ];
    },
    doCalculation: function(){
      this.calculation = true;

      var post = {};
      for(var item in this.values){
        post[item] = this.values[item].value;
      }
      
      axios.post('https://api.sheetpilecorrosioncalculator.com/api/calculator', post)
          .then(response => {
            this.result = response.data.result;
          })
          .catch(error => {
            console.log(error);
          });
      
    },
    emailCalculation: function(){
      this.loading = true;
      var post = {};
      for(var item in this.values){
        post[item] = this.values[item].value;
      }
      post['sent_email'] = true;
      
      axios.post('https://api.sheetpilecorrosioncalculator.com/api/calculator', post)
          .then(response => {
            this.confirm = response.data;
            this.sent_email = true;
            this.loading = false;
          })
          .catch(error => {
            this.confirm.error = true;
            this.confirm.message = error;
            this.sent_email = true;
            this.loading = false;
          });
      
    },
    showResultInput: function(key){
      var inputKeys = [
                        'profiletype',
                        'profile_id',
                        'steelquality_id',
                        'protectionfront',
                        'protectionback',
                        'norm_id',
                        'lifespan',
                        'front_corrosion_id',
                        'front_mm_total',
                        'front_mm_rate',
                        'back_corrosion_id',
                        'back_mm_total',
                        'back_mm_rate',
                      ];

      var resultKeys = [
                        'g_kgm2',
                        'corrosiontotal_front',
                        'corrosiontotal_back',
                      ];

      if(resultKeys.indexOf(key)>=0){
        return true;
      }

      if(inputKeys.indexOf(key)>=0){
        if(this.values[key].visible){
          return true;
        }
      }
      return false;
    },
    demo(){
      this.agreeVal = true;
      this.values['profiletype'].value = '2',
      this.values['profile_id'].value = '63',
      this.values['steelquality_id'].value = '3',
      this.values['protectionfront'].value = '0',
      this.values['protectionback'].value = '0',
      this.values['norm_id'].value = '5',
      this.values['norm_id'].visible = true,
      this.values['lifespan'].value = '30',
      this.values['lifespan'].visible = true,
      this.values['front_corrosion_id'].value = '31',
      this.values['front_corrosion_id'].visible = true,
      this.values['front_mm_total'].value = false,
      this.values['front_mm_rate'].value = false,
      this.values['back_corrosion_id'].value = '37',
      this.values['back_corrosion_id'].visible = true,
      this.values['back_mm_total'].value = false,
      this.values['back_mm_rate'].value = false,
      this.values['projectnaam'].value = '',
      this.values['naam'].value = '',
      this.values['firma'].value = '',
      this.values['emailadres'].value = 'bas@baszwaag.nl',
      this.values['optin'].value = '1',

      this.normValues();
      this.profielenApi(2);
      this.getTranslations();
      this.doCalculation();
    }
  },
  mounted: function(){
    this.getTranslations();
    this.resetCalculation();

    axios.get('https://api.sheetpilecorrosioncalculator.com/api/staalkwaliteiten')
          .then(response => {
            var steel = new Array();
            for (var i = 0; i < response.data.data.length; i++) {
              let id = response.data.data[i].id;
              let name = response.data.data[i].name;
              steel[id] = {'value' : id, 'text' : name};
            }
            this.values.steelquality_id.values = steel;
          })
          .catch(error => {
            console.log(error);
          });
  },

}
</script>



// WEBPACK FOOTER //
// src/Spcc.vue